import { render, staticRenderFns } from "./EPMEvaluationBibliographicResourceForm.vue?vue&type=template&id=295e83d3&scoped=true"
import script from "./EPMEvaluationBibliographicResourceForm.vue?vue&type=script&lang=js"
export * from "./EPMEvaluationBibliographicResourceForm.vue?vue&type=script&lang=js"
import style0 from "./EPMEvaluationBibliographicResourceForm.vue?vue&type=style&index=0&id=295e83d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295e83d3",
  null
  
)

export default component.exports